import { AsyncPipe, DecimalPipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Input, input, output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { ByteToMegaBytePipe } from '@ebeihilfe/core';
import { Beleg, CurrentBelegSizePipe, Seite } from '@ebeihilfe/einreichung-old';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-beleg',
  templateUrl: './beleg.component.html',
  styleUrls: ['./beleg.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatExpansionModule,
    MatIcon,
    CurrentBelegSizePipe,
    AsyncPipe,
    ByteToMegaBytePipe,
    TranslateModule,
    MatIconButton,
    UpperCasePipe,
    DecimalPipe,
    MatButton,
  ],
})
export class BelegComponent {
  public beleg = input.required<Beleg>();
  public belegIndex = input.required<number>();
  public canRemoveBeleg = input<boolean>(false);
  public isMandatory = input<boolean>(false);
  public pagesNeeded = input<number>(0);
  public isFirst = computed(() => {
    return this.belegIndex() === 0;
  });
  public hasEnoughPages = computed(() => {
    if (this.isMandatory()) {
      return this.pagesNeeded() !== 0 && this.beleg().seiten.length >= this.pagesNeeded();
    }
    return false;
  });

  public addNewSeiteToBeleg = output<void>();
  public deleteBelegModal = output<void>();
  public moveBelegToTopEmitter = output<void>();
  public openModal = output<Seite>();
  public removeFileFromDocument = output<Seite>();

  private _currentFocusButton: MatButton | null;

  @Input() public set focusMoveUpBtn(_: Record<string, never>) {
    if (!this._currentFocusButton) {
      return;
    }
    this._currentFocusButton._elementRef.nativeElement.focus();
    this._currentFocusButton = null;
  }

  public addSeiteToBeleg(): void {
    this.addNewSeiteToBeleg.emit();
  }

  public deleteMe(event: Event): void {
    event.stopPropagation();
    this.deleteBelegModal.emit();
  }

  public moveToTop(event: Event, btnToFocus: MatButton): void {
    this._currentFocusButton = btnToFocus;
    event.stopPropagation();
    this.moveBelegToTopEmitter.emit();
  }

  public openImage(seite: Seite): void {
    this.openModal.emit(seite);
  }

  public removeFileFromBeleg(seite: Seite): void {
    this.removeFileFromDocument.emit(seite);
  }
}
